import { useEffect, useState } from 'react';
import { HoldingClass, Range, Share } from 'types';
import { getShareRangeFromByHoldingClass } from '../utils/getShareRangeFromByHoldingClass';

type UseGetRangesProps = {
  holdingClassId: string;
  holdingClasses: HoldingClass[];
  shares: Share[];
  sharesCount: number;
  useFirstAvailableRange: boolean;
};

type RangeFromByHoldingClass = {
  [key: string]: number;
};

const getFirstAvailableRange = (
  holdingClassId: string,
  shares: Share[],
  sharesCount: number
): Range => {
  const filterShares = shares.filter(
    (share) => share.shareClass?._id === holdingClassId && share?.isActive
  );
  const sortedShares = filterShares.sort((a, b) => a.from - b.from);

  // eslint-disable-next-line
  for (let i = 0; i < sortedShares.length - 1; i++) {
    const share = sortedShares[i];
    const nextShare = sortedShares[i + 1];

    const availableShares = nextShare.from - 1 - share.to;

    if (availableShares >= sharesCount && availableShares > 0) {
      return {
        from: share.to + 1,
        to: share.to + (sharesCount > 0 ? sharesCount : 1),
      };
    }
  }
  const lastShare = sortedShares[sortedShares.length - 1];
  if (lastShare) {
    return {
      from: lastShare.to + 1,
      to: lastShare.to + (sharesCount > 0 ? sharesCount : 1),
    };
  }
  return { from: 1, to: sharesCount };
};

export const useGetRange = ({
  holdingClassId,
  holdingClasses,
  shares,
  sharesCount,
  useFirstAvailableRange,
}: UseGetRangesProps) => {
  const [shareRangeFromByHoldingClass, setShareRangeFromByHoldingClass] =
    useState<RangeFromByHoldingClass>({});
  const [from, setFrom] = useState<number>(0);
  const [to, setTo] = useState<number>(0);
  const [currentShares, setCurrentShares] = useState<Share[]>(shares);

  useEffect(() => {
    if (useFirstAvailableRange) {
      console.log(currentShares);
      const availableRange = getFirstAvailableRange(
        holdingClassId,
        currentShares,
        sharesCount
      );

      setFrom(availableRange.from);
      setTo(availableRange.to);
    } else {
      const shareRangeFrom = shareRangeFromByHoldingClass[holdingClassId];
      const shareRangeTo =
        shareRangeFrom + (sharesCount > 0 ? sharesCount - 1 : sharesCount);

      setFrom(shareRangeFrom);
      setTo(shareRangeTo);
    }
  }, [
    holdingClassId,
    currentShares,
    sharesCount,
    useFirstAvailableRange,
    shareRangeFromByHoldingClass,
  ]);

  useEffect(() => {
    const sharesRangeFromByHoldingClass = getShareRangeFromByHoldingClass(
      holdingClasses,
      currentShares
    );
    setShareRangeFromByHoldingClass(sharesRangeFromByHoldingClass);
  }, [holdingClasses, currentShares]);

  const handleAddShare = (newShare: Share) => {
    const newShares = [...currentShares, newShare];
    setCurrentShares(newShares);
  };

  return {
    data: { from, to },
    actions: { handleAddShare },
    isLoading: false,
    isError: false,
  };
};
